import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import ContractsTab from './components/ContractsTab';
import FinanceSectionPage from './components/FinanceSectionPage';
import GenericButton, { GenericButtonTypeEnum } from '../../components/GenericButton';

/**
 * Which children can be invoiced: a contract number, a payer and a price each.
 *
 * Not configuration but the list worked through before a month is billed, which is why it
 * sits beside invoices and debts rather than under billing setup.
 */
const FinanceContractsPage: React.FC = () => {
  const { t } = useTranslation();
  const [assignOpen, setAssignOpen] = useState(false);
  return (
    <FinanceSectionPage
      title={t('nav.financeItems.contracts')}
      description={t('finance.pages.contractsDescription')}
      actions={({ ready }) => (
        <GenericButton
          buttonType={GenericButtonTypeEnum.Secondary}
          variant="outlined"
          startIcon={<AutoFixHighOutlinedIcon />}
          label={t('contracts.assignNumbers')}
          onClick={() => setAssignOpen(true)}
          disabled={!ready}
        />
      )}
    >
      {({ kindergartenId, kindergartenName }) => (
        <ContractsTab
          kindergartenId={kindergartenId}
          kindergartenName={kindergartenName}
          assignOpen={assignOpen}
          onAssignClose={() => setAssignOpen(false)}
        />
      )}
    </FinanceSectionPage>
  );
};

export default FinanceContractsPage;
